import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { DirectivesModule, PanelCsvFilelds } from 'cloud-shared-lib';

interface ICsvFieldSettingsDialogData {
  columnFields: PanelCsvFilelds;
  disabledForm: boolean;
}

@Component({
  selector: 'cloud-csv-field-settings-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    DirectivesModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './csv-field-settings-dialog.component.html',
  styles: [
    `
      table.simple tbody tr td {
        padding-top: 8px !important;
        padding-bottom: 8px !important;
      }
    `,
  ],
})
export class CsvFieldSettingsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ICsvFieldSettingsDialogData) {}
}
